<!-- <FormInput
      name="email"
      type="email"
      label="Ваш email"
      v-model="form.email"
    /> -->

<template>
  <div ref="formInput"
    class="form-input"
    :class="classes">
    <div class="form-input__inner">
      <input v-if="type === 'tel'"
        v-bind="$attrs"
        :id="name"
        v-model="inputValue"
        v-mask="'+7 (###)-###-##-##'"
        type="tel"
        :name="name"
        :placeholder="placeholder"
        class="form-input__field"
        @focus="handleFocus"
        @blur="handleBlur">
      <input v-else-if="type === 'password'"
        v-bind="$attrs"
        :id="name"
        v-model="inputValue"
        type="password"
        autocomplete
        :name="name"
        :placeholder="placeholder"
        class="form-input__field"
        @focus="handleFocus"
        @blur="handleBlur">

      <input v-else-if="type === 'email'"
        v-bind="$attrs"
        :id="name"
        v-model="inputValue"
        type="email"
        :name="name"
        :placeholder="placeholder"
        class="form-input__field"
        @focus="handleFocus"
        @blur="handleBlur">
      <input v-else
        v-bind="$attrs"
        :id="name"
        v-model="inputValue"
        :name="name"
        :placeholder="placeholder"
        class="form-input__field"
        @focus="handleFocus"
        @blur="handleBlur">
    </div>
    <transition name="error"
      appear>
      <div class="form-input__error">
        <span v-if="type == 'text'"> Это поле нам нужно </span>
        <span v-else-if="type == 'tel'">Телефон нам, все-таки, понадобится</span>
        <span v-else-if="type == 'password'">Без пароля никак</span>
        <span v-else-if="type == 'email'">Вы точно указали свою почту?</span>
        <span v-else> Это поле нам нужно </span>
      </div>
    </transition>
  </div>
</template>
<script>
import { mask } from "vue-the-mask";
import { computed, reactive } from "vue";

export default {
  name: "FormInput",
  directives: { mask },

  props: {
    name: {
      type: String,
      default: "inputName",
    },
    label: {
      type: [String, Boolean],
      default: false,
    },
    type: {
      type: [String, Boolean],
      default: false,
    },
    isDark: {
      type: [String, Boolean],
      default: false,
    },
    placeholder: {
      type: String,
      default: ''
    }
  },

  setup(props) {
    props = reactive(props);

    return {
      classes: computed(() => ({
        "_is-dark": props.isDark,
      })),
    };
  },

  data() {
    return {
      inputValue: "",
      isFixedLabel: false,
    };
  },

  mounted() {
    if (this.value) {
      this.inputValue = this.value;
      this.isFixedLabel = true;
    }
  },

  methods: {
    handleFocus() {
      this.isFixedLabel = true;

      this.$refs.formInput.classList.remove("_error");
    },

    handleBlur(event) {
      const inputValue = event.currentTarget.value;

      if (!inputValue) {
        this.isFixedLabel = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-input {
  $that: &;

  position: relative;
  width: 100%;

  &__inner {
    position: relative;
    overflow: hidden;
  }

  &__label {
    width: 100%;
    padding-left: 16px;
    color: $color_dark-50;
    pointer-events: none;
    will-change: transform;
    transition: transform 0.3s ease, background-color 0.3s ease;
    transform-origin: top left;

    ._is-dark & {
      color: $color_dark-40;
    }
  }

  &__field {
    width: 100%;
    padding: 0 28px;
    height: 46px;
    border: 1px solid $color_dark-80;
    border-radius: 24px;
    transition: color 0.3s ease, border 0.3s ease;
    background-color: $color_dark-20;
    font-size: 14px;
    line-height: 1;
    text-transform: uppercase;

    ._is-dark & {
      background-color: $color_dark-90;
      border: 1px solid $white;
      color: $white;
    }

    #{$that}._error & {
      color: $color_primary;
    }

    &::placeholder {
      color: currentColor;
      letter-spacing: .5px;
    }

    &::focus {
      border-color: $color_orange-50;
    }

    @include phone {
      height: 36px;
      font-size: 16px !important;
      padding: 2px 20px;
    }
  }

  &__error {
    color: $color_primary;
    margin-top: 2px;
    font-size: 12px;
    line-height: 16px;
    opacity: 0;
    visibility: hidden;

    ._error & {
      opacity: 1;
      visibility: visible;
    }
  }
}

.error-enter-active {
  transition: opacity 0.5s, transform 0.5s;
}

.error-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}

.error-enter {
  opacity: 0;
  transform: translate(8px, 0);
}

.error-leave-to {
  opacity: 0;
  transform: translate(0, 2px);
}
</style>
